import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import Input from '../input';
import Calendar from './Calendar';
import CalendarToday from '../icons/internals/CalendarToday';
import Tooltip from '../tooltip';
import Button from '../button';

class DatePicker extends React.Component {
  static propTypes = {
    /**
     * 类前缀
     * */
    prefixCls: PropTypes.string,
    /**
     * 分隔符
     * */
    separator: PropTypes.node,
    /**
     * 选择类型
     * */
    selectType: PropTypes.oneOf(['date', 'month', 'year']),
    /**
     * 是否禁用
     */
    disabled: PropTypes.bool,
    /**
     * 日期显示格式
     */
    format: PropTypes.string,
    /**
     * 是否可以选择时刻
     */
    showTime: PropTypes.oneOfType([PropTypes.string, PropTypes.string]),
    /**
     * 后缀
     */
    suffix: PropTypes.node,
    /**
     * 占位文本
     */
    placeholder: PropTypes.node,
    /**
     * input元素的值，受控模式下使用
     */
    defaultValue: PropTypes.object,
    /**
     * 不可选择的时间范围
     */
    disabledTime: PropTypes.func,
    /**
     *  scrollContainer Tooltip兼容自定义可滚动容器
     */
    scrollContainer: PropTypes.node,
    /**
     * 时间格式化之后的回调函数，可以将格式化后的时间处理成需要的特殊格式
     * */
    onFormatDate: PropTypes.func,
  };

  static defaultProps = {
    disabled: false,
    format: 'YYYY-MM-DD',
    clearable: false,
    separator: '-',
    selectType: 'date',
    showTime: false,
    prefixCls: 'ne-date-picker',
    placeholder: '',
    suffix: <CalendarToday />,
    scrollContainer: '',
    onFormatDate: date => date,
  };

  static getDerivedStateFromProps(props, state) {
    const { defaultValue } = props;
    if (defaultValue !== state.prevDefaultValue) {
      return {
        value: defaultValue,
        prevDefaultValue: defaultValue,
      };
    }
    return null;
  }

  constructor(props) {
    super(props);
    /**
     * 初始化默认值，对空默认值进行处理
     * */
    const { defaultValue, selectType } = props;

    this.state = {
      value: defaultValue,
      prevDefaultValue: defaultValue,
      panelType: selectType,
    };
  }

  handleValueChange = value => {
    const { onChange, onFormatDate } = this.props;
    const date = onFormatDate(value);
    this.setState({
      value: date,
    });
    if (onChange) {
      onChange(date);
    }
    if (this.inputRef) this.inputRef.focus();
  };

  handlePanelTypeChange = type => {
    this.setState({
      panelType: type,
    });
  };

  handleClear = () => {
    const { onChange } = this.props;
    this.setState({
      value: '',
      panelType: 'date'
    });
    if (onChange) {
      onChange(null);
    }
  };

  getInputRef = el => {
    this.inputRef = el;
  };

  render() {
    const {
      prefixCls,
      selectType,
      readOnly,
      format,
      placeholder,
      disabled,
      showTime,
      suffix,
      inputProps,
      size,
      status,
      clearable,
      onChange,
      clearIcon,
      errorIcon,
      loadingIcon,
      showStatusIcon,
      successIcon,
      style,
      scrollContainer,
      ...other
    } = this.props;

    const { value, panelType } = this.state;

    return (
      <Tooltip
        position="bottom"
        trigger="click"
        className={prefixCls}
        disabled={disabled}
        autoAdjustPosition
        scrollContainer={scrollContainer}
        content={
          <Input
            style={style}
            inputRef={this.getInputRef}
            size={size}
            suffix={suffix}
            placeholder={placeholder}
            disabled={disabled}
            clearable={clearable}
            onClear={this.handleClear}
            clearIcon={clearIcon}
            errorIcon={errorIcon}
            loadingIcon={loadingIcon}
            successIcon={successIcon}
            status={status}
            showStatusIcon={showStatusIcon}
            value={value ? moment(value).format(format) : ''}
            readOnly
            {...inputProps}
          />
        }>
        <Calendar
          panelType={panelType}
          onPanelTypeChange={this.handlePanelTypeChange}
          value={value ? (value._isAMomentObject ? value : moment(value)) : moment()}
          onValueChange={this.handleValueChange}
          onTimeChange={this.handleValueChange}
          selectType={selectType}
          showTime={showTime}
          {...other}
        />
        {value && showTime && (panelType === 'date' || panelType === 'time') ? (
          <div className={`${prefixCls}-footer`}>
            {panelType === 'date' ? (
              <Button variant="text" onClick={() => this.handlePanelTypeChange('time')}>
                时间
              </Button>
            ) : panelType === 'time' ? (
              <Button variant="text" onClick={() => this.handlePanelTypeChange('date')}>
                日期
              </Button>
            ) : null}
          </div>
        ) : null}
      </Tooltip>
    );
  }
}

export default DatePicker;



// WEBPACK FOOTER //
// ./src/datePicker/DatePicker.jsx